import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 90 90\" id=\"left\">\n  <path fill=\"#37322F\" fill-rule=\"evenodd\" d=\"M23.3 47.795 55.495 79.99l2.3-2.3-32.196-32.195L57.795 13.3l-2.3-2.3L23.3 43.195l-2.3 2.3 2.3 2.3Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol